"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Reload = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Reload"));

// Generated by script, don't edit it please.
var Reload = (0, _createSvgIcon["default"])({
  as: _Reload["default"],
  ariaLabel: 'reload',
  category: 'action',
  displayName: 'Reload'
});
var _default = Reload;
exports["default"] = _default;
module.exports = exports.default;